export const setGlobalState = (store) => {
    const userData = JSON.parse(localStorage.getItem('user'));
    store.setState({ userData: userData })
};
export const setImageUpload = (store, value) => {
    store.setState({ imageUpload: value });
}
export const setImageUrls = (store, value) => {
    store.setState({ image_urls: value });
}
export const setExpand = (store, value) => {
    store.setState({ expand: value });
}
export const setOpen = (store, value) => {
    store.setState({ openMenu: value });
}
export const setNavData = (store, value) => {
    store.setState({navData: value})
}
export const broadCastNotif = (store, value, data) => {
    const notif = data ? JSON.parse(data) : null;
    if (localStorage.getItem('notif') && process.env.REACT_APP_HOTEL) {
        const data = JSON.parse(localStorage.getItem('notif'));
        store.state.notifData = data;
        store.state.notifData.push({ id: notif.order_type_id });
        localStorage.setItem('notif', JSON.stringify(store.state.notifData));
    } else {
        if (notif) {
            store.state.notifData = [];
            store.state.notifData.push({ id: notif.order_type_id });
            localStorage.setItem('notif', JSON.stringify(store.state.notifData));
        }
    }
    store.setState({
        notifRuntime: !value
    });
}
export const setModuleOnEnteringMenu = (store, id, value) => {
    store.setState({ moduleId: id, openMenu: value });
}
export const setQiscusComment = (store, array) => {
    store.state.notifData = [];
    store.setState({ qiscusComment: array });
}
export const setQiscusCommentList = (store, array) => {
    store.setState({ qiscusCommentList: array });
}